import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5eb4fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "summary" }
const _hoisted_2 = {
  class: "linkable",
  href: "#education",
  style: {"--linkable-color":"var(--red)"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Education and Coursework", -1))
const _hoisted_4 = { class: "data" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "conjunction" }, "and", -1))
const _hoisted_6 = {
  class: "linkable",
  href: "#work",
  style: {"--linkable-color":"var(--green)"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Internships and Research", -1))
const _hoisted_8 = { class: "data" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "conjunction" }, "and", -1))
const _hoisted_10 = {
  class: "linkable",
  href: "#projects",
  style: {"--linkable-color":"var(--blue)"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Skills and Expertise", -1))
const _hoisted_12 = { class: "data" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "conjunction" }, "and", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_vue = _resolveComponent("icon-vue")!
  const _component_numbered_stat = _resolveComponent("numbered-stat")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("a", _hoisted_2, [
        _createVNode(_component_icon_vue, {
          color: 'red',
          icon: 'school'
        }),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_numbered_stat, {
          name: 'Undergraduate Majors',
          number: 2,
          subtext: 'Computer Science Engineering and Bioengineering'
        }),
        _hoisted_5,
        _createVNode(_component_numbered_stat, {
          name: 'Classes',
          number: _ctx.classes.length,
          subtext: 'Engineering, Science, Math, Design'
        }, null, 8, ["number"])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("a", _hoisted_6, [
        _createVNode(_component_icon_vue, {
          color: 'green',
          icon: 'science'
        }),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_numbered_stat, {
          name: 'Internships',
          number: _ctx.internships.length,
          subtext: Array.from(new Set(_ctx.internships.map(i => i.company))).join(', ')
        }, null, 8, ["number", "subtext"]),
        _hoisted_9,
        _createVNode(_component_numbered_stat, {
          name: 'Research Groups',
          number: _ctx.research.length,
          subtext: Array.from(new Set(_ctx.research.map(i => i.company))).join(', ')
        }, null, 8, ["number", "subtext"])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("a", _hoisted_10, [
        _createVNode(_component_icon_vue, {
          color: 'blue',
          icon: 'devices'
        }),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_numbered_stat, {
          name: 'Programming Languages',
          number: _ctx.languages.length,
          subtext: _ctx.languages.join(', ')
        }, null, 8, ["number", "subtext"]),
        _hoisted_13,
        _createVNode(_component_numbered_stat, {
          name: 'Focus Areas',
          number: _ctx.focuses.length,
          subtext: _ctx.focuses.join(', ')
        }, null, 8, ["number", "subtext"])
      ])
    ])
  ]))
}